<template>
    <div class="container">

        <loading-state
                v-if="loading">
        </loading-state>

        <div class="title">
            <h1>Problems <button class="btn btn-success" @click="$bvModal.show('add-problem-modal')">Add Problem</button></h1>
        </div>

        <div class="card px-2" v-if="problems.length === 0">
            <empty-state
                    title="No problems have been added"
                    subtitle="Click the button above to get started">
            </empty-state>
        </div>

        <template v-else>
            <div class="card card-body pb-2 mb-3" v-for="(problem, index) in problems" :key="index">
                <dl class="mb-0">
                    <dd>{{problem.title}}</dd><dt v-for="(symptom, symptomIndex) in problem.symptoms" :key="symptomIndex+Math.random()">{{symptom.title}}</dt>
                </dl>
            </div>
        </template>

        <!-- Footer -->
        <fixed-footer
                :class="{'active': footerActive}"
                :nextLabel="`Next`"
                :nextRoute="`revisit.repair-parts`"
                :prevRoute="`job`">
        </fixed-footer>

        <add-problem-modal></add-problem-modal>
        <problem-symptom-modal></problem-symptom-modal>
    </div>
</template>

<script>
    export default {
        name: "DeviceIssues",

        data() {
            return {
                loading: true,
                problems: []
            }
        },

        mounted() {
            this.reloadProblems();

            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                if (modalId === 'problem-symptom-modal') {
                    this.reloadProblems();
                }
            })
        },

        computed: {
            /** Check if footer should be active */
            footerActive() {
                if (this.problems.length > 0) {
                    return true;
                }

                return false;
            }
        },

        methods: {
            reloadProblems() {
                this.loading = true;
                this.$http.get(`/api/v4/warranty/booking/${localStorage.revisitBookingId}`)
                    .then(res => {
                        this.loading = false;
                        this.problems = res.data.data.problems;

                        this.problemStillHasSymptoms();
                    })
            },

            problemStillHasSymptoms() {
                this.problems.forEach(problem => {
                    if (problem.symptoms.length === 0) {
                        this.$http.delete(`/api/v4/warranty/booking/${localStorage.revisitBookingId}/problem/${problem.id}`);
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
